<template>
  <section>
    <!-- ROUTER HEADER SHOULD GO HERE -->
    <div class="page-banner">
      <div class="container-fluid border-bottom">
        <div class="row align-items-center">
          <div class="col-md-7 p-4 pt-5">
            <h1>
              <img
                src="@/assets/img/_title/14-IP-reflect-on-the-interview-to-learn-and-grow.svg"
                class="img-fluid"
                alt="Reflect on the interview to learn and grow"
                srcset=""
              >
            </h1>
          </div>
          <div class="col-md-5">
          </div>
        </div>
      </div>
    </div>

    <!-- ROUTER CONTENT GOES HERE -->

    <!-- TEXT CONTENT -->
    <content-block class="bg-light-grey">
      <div class="row">
        <div class="col-md bg-img bg-img--interview-prep-04">
          <!-- <img
            src="@/assets/img/_content/template-placeholder-01.jpg"
            alt=""
            class="img-fluid content-block__img"
          > -->
        </div>
        <div class="col-md-8 p-4">
          <p>Every interview is an opportunity to learn and improve your interviewing skills.</p>
          <p>Here’s what you can do after the interview to maximize your learning experience and leave a good impression:</p>
          <ul>
            <li>Reflect honestly on your interview performance</li>
            <li>Write down the questions you were asked to help you prepare for your next interview</li>
            <li>Within 24 hours, send a thank-you email to the interviewer to…</li>
            <ul>
              <li>Demonstrate your appreciation for the employer’s time and interest in you</li>
              <li>Restate your interest in the position and working for the department</li>
              <li>Remind the employer about your qualifications</li>
            </ul>
          </ul>
          <p>Remember that even if you don’t get a job offer, you haven’t wasted your time. You’ve practiced talking about your skills, and this will pay off in future interviews.</p>
          <div class="learn-more learn-more--blue">
            <p><strong>Learn more</strong>
            <ul>
              <li><a :href="`${publicPath}docs/Tip sheets and other materials/7-Interview tips for success.pdf`"
                target="_blank">General interview tips</a></li>
              <li><a href="https://centennialcollege.biginterview.com/" target="_blank">Big Interview</a> (Hire Centennial)</li>
              <li><a href="https://www.youtube.com/watch?v=HG68Ymazo18" target="_blank">Top interview tips video</a></li>
            </ul></p>
          </div>
        </div>
      </div>
    </content-block>
  </section>
</template>

<script>
import ContentBlock from '@/components/ContentBlock.vue'
// import Accordion from '@/components/Accordion.vue'
// import SidebarMenu from '../components/SidebarMenu.vue'
// import {
//   Hooper,
//   Slide,
//   Navigation as HooperNavigation,
//   Pagination as HooperPagination
// } from 'hooper'
// import 'hooper/dist/hooper.css'

export default {
  name: '01',
  components: {
    ContentBlock
    // SidebarMenu,
    // Accordion,
    // Hooper,
    // Slide,
    // HooperNavigation,
    // HooperPagination
  },
  data () {
    return {
      publicPath: process.env.BASE_URL
    }
  },

  mounted () {
  }
}
</script>

<style>
</style>
